import { render, staticRenderFns } from "./ReasonView.vue?vue&type=template&id=f3c97052&"
import script from "./ReasonView.vue?vue&type=script&lang=js&"
export * from "./ReasonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports